import { createFileRoute } from '@tanstack/react-router';
import AttachmentsView from '../jobs/view/attachments/attachments-view';

export const Route = createFileRoute('/orders/$orderGuid_/jobs/$jobGuid/attachments')({
  component: AttachmentsView,
});
